import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/california/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Tailored Mobile App Solutions For Diversified Industries</h2>
            </div>
            <p>
              With our seasoned team of designers, developers, and business
              development professionals, we craft exceptional apps custom-made
              for businesses of all sizes. Whether it’s real estate, fashion,
              medical, and other industries, our expert app developers in
              Florida are always there to bring feature-rich, customer-centric
              mobile applications. As your business and technology partner, we
              classify and utilize the most profitable growth opportunities,
              using our technical ability at maximum power. Our growth-oriented
              approach guarantees maximum productivity and success, guiding you
              towards a successful digital transformation journey. Choose
              TekRevol for groundbreaking solutions that reform your business
              landscape in Florida.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
